import React from 'react';
import UserService from '../../../../Services/userService';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';

export default class CommissionUserSelect extends React.Component {
  static defaultProps = {
    value: '',
    className: '',
    onChange: () => alert('CommissionUserMultiChoice Onchange'),
    fieldName: '',
    filterCleared: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {}

  populateListData() {
    UserService.GetUserListForCommission(false)
      .then((result) => {
        let optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((user) => {
          if (user.isActive === true) {
            const newValue = {
              label: `${user.firstName}, ${user.lastName} (${user.userId})`,
              value: user.userId,
            };
            optValues.push(newValue);
          }
        });
        this.setState({
          selectValues: optValues,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('CMUS51');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
